export const translitiration = state =>
  state.translitiration.writeRranslitiration;

export const translitirationError = state =>
  state.translitiration.writeRranslitirationError;
